import React from 'react'
import * as Utils from 'Assets/Utils'

import { List, Map } from 'immutable'

import ClientHttpRequest from "Api/ClientHttpRequest"
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Map({}).set('questions',
	new Map({}).set('preguntas',
		new Map({}).set('pregunta',
			new List([])))).set('answers',
				new Map({}).set('exportReport'));

/* Types */
export const GET_QUESTIONS = 'GET_QUESTIONS'
export const SET_ANSWERS = 'SET_ANSWERS'
export const EXPORT_REPORT = 'EXPORT_REPORT'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_QUESTIONS:
			return state.set('questions', new Map(action.Obj))
		case SET_ANSWERS:
			return state.set('answers', new Map(action.Obj))
		case EXPORT_REPORT:
			return state.set('exportReport', new Map(action.Obj))
		default:
			return state;
	}
}
/* Action Creators */

export const getQuestions = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getQuestions',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false));

			const data = response.data
			let answers = { uniqueId: Utils.getUUID() }
			let objetivos = []
			if (data) {
				data.preguntas.pregunta.forEach(d => {
					let idPregunta = d.idPregunta
					let idPreguntaPadre = d.idPreguntaPadre ? d.idPreguntaPadre : idPregunta
					let tipo = d.tipo.id
					if(!d.seccion){
						d.seccion = "Preguntas generales"
					}

					if (tipo === 1) { //Especial
						switch (idPreguntaPadre) {
							case 1:
								answers = {
									...answers,
									'SPQ-1': {
										'SPQ1-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ1-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : ''
									}
								}
								break
							case 2: {

								answers = {
									...answers
								}

								if (d.formularios.formulario[0].respuestas.respuesta[0] && (d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0])) {

									let objetivo = Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) }) ? Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) }): {}

									let objetivoObj = { id: objetivo.idObjetivo, objetivo }
									let metas = []

									if (objetivo.metas) {

										d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta.forEach((m, indexMeta) => {

											let meta = Utils.getItem(objetivo.metas.meta, { idMeta: parseInt(m) })
											if (meta) {
												let metaObj = { idObjetivo: objetivo.idObjetivo, idMeta: meta.idMeta, meta }
												let idIndicadoresCobertura = d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ?
																											d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] : ""
												let idIndicadoresCoberturaMetas = d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[indexMeta === 0 ? 0 : indexMeta]
												let idIndicadoresResultados = d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ?
																												d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] : ""
												let idIndicadoresResultadosMetas = d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta[indexMeta === 0 ? 0 : indexMeta]
												const IndicadoresCobertura = () => {
													const iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : []
													const indicatorsList = iteratorList.map((i, index) => {
														let { descripcion } = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) })
														let metaItem = idIndicadoresCoberturaMetas.split(",")
														return (
															<li key={descripcion.toString()}>
																<p>
																	{descripcion}
																	<br />
																	<small>{`Meta institución: ${metaItem[index]}`}</small>
																</p>
															</li>
														)
													})
													return (
														<ul className="indicadores-question">
															{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
														</ul>
													)
												}

												let IndicadoresResultados = () => {
													const iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : []
													const indicatorsList = iteratorList.map((i, index) => {
														let { descripcion } = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) })
														let metaItem = idIndicadoresResultadosMetas.split(",")
														return (
															<li key={descripcion.toString()}>
																<p>
																	{descripcion}
																	<br />
																	<small>{`Meta institución: ${metaItem[index]}`}</small>
																</p>
															</li>
														)
													})
													return (
														<ul className="indicadores-question">
															{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
														</ul>
													)
												}

												metaObj = {
													...metaObj,
													idObjetivo: objetivo.idObjetivo,
													idIndicadoresCobertura,
													idIndicadoresResultados,
													idIndicadoresCoberturaMetas,
													idIndicadoresResultadosMetas,
													indicadoresCobertura: <IndicadoresCobertura />,
													indicadoresResultados: <IndicadoresResultados />
												}
												metas.push(metaObj)
											}

										})
										objetivoObj = {...objetivoObj, metas}
										objetivos.push(objetivoObj)
									}
								}

								if (d.formularios.formulario[0].respuestas.respuesta[6] && d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[0]) {

									let objetivo = Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[0]) }) ? Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[0]) }) : {}
									let objetivoObj = { id: objetivo.idObjetivo, objetivo }
									let metas = []

									if (objetivo.metas) {

										d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta.forEach((m, indexMeta) => {

											let meta = Utils.getItem(objetivo.metas.meta, { idMeta: parseInt(m) })

											if (meta) {

												let metaObj = { idObjetivo: objetivo.idObjetivo, idMeta: meta.idMeta, meta }
												let idIndicadoresCobertura = d.formularios.formulario[0].respuestas.respuesta[8].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ?
																				d.formularios.formulario[0].respuestas.respuesta[8].textoRespuesta[indexMeta === 0 ? 0 : 1] : ""
												let idIndicadoresCoberturaMetas = d.formularios.formulario[0].respuestas.respuesta[9].textoRespuesta[indexMeta === 0 ? 0 : indexMeta]

												let idIndicadoresResultados = d.formularios.formulario[0].respuestas.respuesta[10].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ?
																				d.formularios.formulario[0].respuestas.respuesta[10].textoRespuesta[indexMeta === 0 ? 0 : 1] : ""
												let idIndicadoresResultadosMetas = d.formularios.formulario[0].respuestas.respuesta[11].textoRespuesta[indexMeta === 0 ? 0 : indexMeta]
												const IndicadoresCobertura = () => {
													const iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : []
													const indicatorsList = iteratorList.map((i, index) => {
														let descripcion = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) }) ? Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) }).descripcion : ''
														let metaItem = idIndicadoresCoberturaMetas.split(",")

														return (
															<li key={descripcion.toString()}>
																<p>
																	{descripcion}
																	<br />
																	<small>{`Meta institución: ${metaItem[index]}`}</small>
																</p>
															</li>
														)
													})
													return (
														<ul className="indicadores-question">
															{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
														</ul>
													)
												}

												let IndicadoresResultados = () => {
													const iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : []
													const indicatorsList = iteratorList.map((i, index) => {
														let { descripcion } = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) })
														let metaItem = idIndicadoresResultadosMetas.split(",")
														return (
															<li key={descripcion.toString()}>
																<p>
																	{descripcion}
																	<br />
																	<small>{`Meta institución: ${metaItem[index]}`}</small>
																</p>
															</li>
														)
													})
													return (
														<ul className="indicadores-question">
															{indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'}
														</ul>
													)
												}

												metaObj = {
													...metaObj,
													idObjetivo: objetivo.idObjetivo,
													idIndicadoresCobertura,
													idIndicadoresResultados,
													idIndicadoresCoberturaMetas,
													idIndicadoresResultadosMetas,
													indicadoresCobertura: <IndicadoresCobertura />,
													indicadoresResultados: <IndicadoresResultados />
												}
												metas.push(metaObj)
											}

										})
										objetivoObj = {...objetivoObj, metas}
										objetivos.push(objetivoObj)
									}
								}
								answers = {
									...answers,
									'SPQ-2': {
										objetivos
									}
								}
							}
								break
							case 3:
								answers = {
									...answers,
									'SPQ-3': {
										'SPQ3-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : 0,
										'SPQ3-C3': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C4': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[1] : 0,
										'SPQ3-C5': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C6': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[2] : 0,
										'SPQ3-C7': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[3] : 0,
										'SPQ3-C8': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[3] : 0,
										'SPQ3-C9': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[4] : 0,
										'SPQ3-C10': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[4] : 0,
										'SPQ3-C11': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[5] : 0,
										'SPQ3-C12': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[5] : 0,
										'SPQ3-C13': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[6] : 0,
										'SPQ3-C14': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[6] : 0,

										'SPQ3-C15': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C16': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C17': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C18': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[3] : 0,

										'SPQ3-C19': d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta[0] : 0,

										'SPQ3-C20': d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ3-C21': d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta[0] : '',

										/*Se agrega columna de otros generos*/
										'SPQ3-C22': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : 0,
										'SPQ3-C23': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[1] : 0,
										'SPQ3-C24': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[2] : 0,
										'SPQ3-C25': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[3] : 0,
										'SPQ3-C26': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[4] : 0,
										'SPQ3-C27': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[5] : 0,
										'SPQ3-C28': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[6] : 0,

										/*Se agrega pregunta de poblacion indigena con discapacidad*/
										'SPQ3-C29': d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ3-C30': d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta[0] : '',

										/*Se agrega pregunta de Su organizacion apoya a otras organizaciones*/
										'SPQ3-C31': d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ3-C32': d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta[0] : '',
										/*Se agrega nuevo campo para especificar de que forma apoya a las organizaciones*/
										'SPQ3-C63': d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta[0] : '',

										/*Se agregan las dos columnas en nivel socioeconómico*/
										'SPQ3-C33': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[0] : 0,
										'SPQ3-C34': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[0] : 0,
										'SPQ3-C35': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[1] : 0,
										'SPQ3-C36': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[1] : 0,
										'SPQ3-C37': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[2] : 0,
										'SPQ3-C38': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[2] : 0,
										'SPQ3-C39': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[3] : 0,
										'SPQ3-C40': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[3] : 0,

										/*Se agrega nueva pregunta de financiamiento NMP*/
										'SPQ3-C41': d.formularios.formulario[6].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[6].respuestas.respuesta[0].textoRespuesta[0]) : '',

										/*Se agrega la tabla ligada a la pregunta nueva*/
										'SPQ3-C42': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C43': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[0] : 0,
										'SPQ3-C44': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[0] : 0,
										'SPQ3-C45': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C46': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[1] : 0,
										'SPQ3-C47': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[1] : 0,
										'SPQ3-C48': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C49': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[2] : 0,
										'SPQ3-C50': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[2] : 0,
										'SPQ3-C51': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[3] : 0,
										'SPQ3-C52': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[3] : 0,
										'SPQ3-C53': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[3] : 0,

										/*Se agrega nueva tabla de personas destinatarias según el tipo de población.*/
										'SPQ3-C54': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C55': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C56': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C57': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[3] : 0,
										'SPQ3-C58': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[4] : 0,
										'SPQ3-C59': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[5] : 0,
										'SPQ3-C60': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[6] : 0,
										'SPQ3-C61': d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta[0] : "",
										'SPQ3-C62': d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta[1] : ""
									}
								}
								break
							case 4: {

								let resp = {}

								if (d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) {
									d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta.forEach((i, index) => {
										resp = {
												...resp,
												[`SPQ4-CP${i}`]: d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[index],
												[`SPQ4-CC${i}`]: d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[index]
										}
										if (d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[index]) {
											d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[index].split(",").forEach((a, b) => {

												let val1 = d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta[index].split('|') || ''
												let val2 = d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[index].split('|') || ''

												resp = {
													...resp,
													[`SPQ4-RP${a}`]: val1[b],
													[`SPQ4-RC${a}`]: val2[b]
												}
											})
										}
									})
								}

								if (d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta[0]) {
									d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta.forEach((i, index) => {
										resp = {
												...resp,
												[`SPQ4-CP${i}`]: d.formularios.formulario[0].respuestas.respuesta[9].textoRespuesta[index],
												[`SPQ4-CC${i}`]: d.formularios.formulario[0].respuestas.respuesta[10].textoRespuesta[index]
										}
										if (d.formularios.formulario[0].respuestas.respuesta[11].textoRespuesta[index]) {
											d.formularios.formulario[0].respuestas.respuesta[11].textoRespuesta[index].split(",").forEach((a, b) => {

												let val1 = d.formularios.formulario[0].respuestas.respuesta[12].textoRespuesta[index].split('|') || ''
												let val2 = d.formularios.formulario[0].respuestas.respuesta[13].textoRespuesta[index].split('|') || ''

												resp = {
													...resp,
													[`SPQ4-RP${a}`]: val1[b],
													[`SPQ4-RC${a}`]: val2[b]
												}
											})
										}
									})
								}

								answers = {
									...answers,
									'SPQ-4': {
										...resp
									}
								}
							}
								break
							case 5:
								answers = {
									...answers,
									'SPQ-5': {
										'SPQ5-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : '',
										'SPQ5-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : '',
										'SPQ5-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta : '',
										'SPQ5-C4': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta : '',
										'SPQ5-C5': d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta : '',

										/*Datos para ORGANIZACIONES DE LA SOCIEDAD CIVIL*/
										'SPQ5-C6': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C7': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C8': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C9': d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para ACADEMIA*/
										'SPQ5-C10': d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C11': d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C12': d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C13': d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para GUBERNAMENTAL*/
										'SPQ5-C14': d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C15': d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C16': d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C17': d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para PRIVADO*/
										'SPQ5-C18': d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C19': d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C20': d.formularios.formulario[4].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C21': d.formularios.formulario[4].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para OTROS ALIADOS NO LISTADOS*/
										'SPQ5-C22': d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C23': d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C24': d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C25': d.formularios.formulario[5].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[3].textoRespuesta[0] : ''
									}
								}
								break
							case 6:
								answers = {
									...answers,
									'SPQ-6': {
										'SPQ6-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : '',
										'SPQ6-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : '',
										'SPQ6-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta : '',
										'SPQ6-C4': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta : '',
										'SPQ6-C5': d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta : '',

										/*INICIA FORMULARIO 2*/
										/*Se agregan nuevos campos modificacion paquete 3*/
										/*Objetivo 1*/
										'SPQ6-C6':  d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ6-C7':  d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ6-C8':  d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[0] : undefined,
										'SPQ6-C9':  d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta[0] : undefined,
										'SPQ6-C10': d.formularios.formulario[1].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[4].textoRespuesta[0] : '',
										'SPQ6-C11': d.formularios.formulario[1].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[5].textoRespuesta[0] : 0,

										'SPQ6-C12': d.formularios.formulario[1].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[6].textoRespuesta[0] : '',
										'SPQ6-C13': d.formularios.formulario[1].respuestas.respuesta[7].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[7].textoRespuesta[0] : undefined,
										'SPQ6-C14': d.formularios.formulario[1].respuestas.respuesta[8].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[8].textoRespuesta[0] : undefined,
										'SPQ6-C15': d.formularios.formulario[1].respuestas.respuesta[9].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[9].textoRespuesta[0] : '',
										/*TERMINA FORMULARIO 2*/

										/*INICIA FORMULARIO 3*/
										/*Se agrega objetivo 2*/
										'SPQ6-C16':  d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ6-C17':  d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ6-C18':  d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta[0] : undefined,
										'SPQ6-C19':  d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta[0] : undefined,
										'SPQ6-C20':  d.formularios.formulario[2].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[4].textoRespuesta[0] : '',

										'SPQ6-C21':  d.formularios.formulario[2].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[5].textoRespuesta[0] : 0,

										'SPQ6-C22':  d.formularios.formulario[2].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[6].textoRespuesta[0] : '',
										'SPQ6-C23':  d.formularios.formulario[2].respuestas.respuesta[7].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[7].textoRespuesta[0] : undefined,
										'SPQ6-C24':  d.formularios.formulario[2].respuestas.respuesta[8].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[8].textoRespuesta[0] : undefined,
										'SPQ6-C25':  d.formularios.formulario[2].respuestas.respuesta[9].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[9].textoRespuesta[0] : '',
										/*TERMINA FORMULARIO 3*/

										/*INICIA FORMULARIO 4*/
										/*Se agrega objetivo 3*/
										'SPQ6-C26':  d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ6-C27':  d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ6-C28':  d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta[0] : undefined,
										'SPQ6-C29':  d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta[0] : undefined,
										'SPQ6-C30':  d.formularios.formulario[3].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[4].textoRespuesta[0] : '',
										/*Se agrega condicional para la actividad 2 objetivo 3*/
										'SPQ6-C31':  d.formularios.formulario[3].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[5].textoRespuesta[0] : 0,
										/*Se agregan nuevas opciones de la actividad 2 objetivo 3*/
										'SPQ6-C32':  d.formularios.formulario[3].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[6].textoRespuesta[0] : '',
										'SPQ6-C33':  d.formularios.formulario[3].respuestas.respuesta[7].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[7].textoRespuesta[0] : undefined,
										'SPQ6-C34':  d.formularios.formulario[3].respuestas.respuesta[8].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[8].textoRespuesta[0] : undefined,
										'SPQ6-C35':  d.formularios.formulario[3].respuestas.respuesta[9].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[9].textoRespuesta[0] : ''
										/*TERMINA FORMULARIO 4*/
									}
								}
								break
							case 7:
								answers = {
									...answers,
									'SPQ-7': {
										'SPQ7-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : '',
										'SPQ7-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : '',
										'SPQ7-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta : '',
										'SPQ7-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta : '',
										'SPQ7-C5': d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta : '',
										'SPQ7-C6': d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta : ''
									}
								}
								break
							case 8: {

							answers = {
								...answers
							}

							let obj = []

							if (objetivos[0]) {
								let indicadores = []
								let objetivosObj = {}
								let indObj = {}

									objetivosObj = {
										id: objetivos[0].objetivo.idObjetivo,
										objetivo:{
											idObjetivo: objetivos[0].objetivo.idObjetivo,
											descripcion: objetivos[0].objetivo.descripcion
										}
									}

									let metodoEvaluacion = d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta || ''
									let metodoVerificacion = d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta || ''

									objetivos[0].metas.forEach(m => {
										if (m.idIndicadoresResultados) {
											m.idIndicadoresResultados.split(",").forEach((i, index) => {
												if (i) {
													let item = Utils.getItem(m.meta.indicadores.indicador, {idIndicador: parseInt(i)})
													indObj = {
														idObjetivo: objetivos[0].objetivo.idObjetivo,
														idIndicador: item.idIndicador,
														descripcion: item.descripcion,
														evaluacion: metodoEvaluacion ? metodoEvaluacion[index] : '',
														verificacion: metodoVerificacion ? metodoVerificacion[index] : ''
													}
													indicadores.push(indObj)
												}
											})
										}
										return m
									})

									if (indicadores.length) {
										objetivosObj = {...objetivosObj, indicadores}
										obj.push(objetivosObj)
									}
							}

							if (objetivos[1]) {

								let indicadores = []
								let objetivosObj = {}
								let indObj = {}

								objetivosObj = {
									id: objetivos[1].objetivo.idObjetivo,
									objetivo:{
										idObjetivo: objetivos[1].objetivo.idObjetivo,
										descripcion: objetivos[1].objetivo.descripcion
									}
								}

								let metodoEvaluacion = d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta || ''
								let metodoVerificacion = d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta || ''

								objetivos[1].metas.forEach( m => {
									if (m.indicadoresResultados) {
										m.idIndicadoresResultados.split(",").forEach((i, index) => {
											if (i) {
												let item = Utils.getItem(m.meta.indicadores.indicador, {idIndicador: parseInt(i)})
												indObj = {
													idObjetivo: objetivos[1].objetivo.idObjetivo,
													idIndicador: item.idIndicador,
													descripcion: item.descripcion,
													evaluacion: metodoEvaluacion ? metodoEvaluacion[index] : '',
													verificacion: metodoVerificacion ? metodoVerificacion[index] : ''
												}
												indicadores.push(indObj)
											}
										})
									}
									return m
								})

								if (indicadores.length) {
									objetivosObj = {...objetivosObj, indicadores}
									obj.push(objetivosObj)
								}
							}

							answers = {
									...answers,
									'SPQ-8': {
										obj
									}
								}
							}
								break
							case 9:
								answers = {
									...answers,
									'SPQ-9': {
										'SPQ9-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ9-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ9-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ9-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ9-C5': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[1] : '',
										'SPQ9-C6': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[1] : '',
										'SPQ9-C7': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[1] : '',
										'SPQ9-C8': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[1] : '',
										'SPQ9-C9': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[2] : '',
										'SPQ9-C10': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[2] : '',
										'SPQ9-C11': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[2] : '',
										'SPQ9-C12': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[2] : '',
										'SPQ9-C13': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[3] : '',
										'SPQ9-C14': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[3] : '',
										'SPQ9-C15': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[3] : '',
										'SPQ9-C16': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[3] : '',
										'SPQ9-C17': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[4] : '',
										'SPQ9-C18': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[4] : '',
										'SPQ9-C19': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[4] : '',
										'SPQ9-C20': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[4] : ''
									}
								}
								break
							case 10:
								answers = {
									...answers,
									'SPQ-10': {
										'SPQ10-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ10-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ10-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ10-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : ''
									}
								}
								break
							case 11:
								answers = {
									...answers,
									'SPQ-11': {
										'SPQ11-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ11-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : ''
									}
								}
								break
							case 12:
								answers = {
									...answers,
									'SPQ-12': {
										'SPQ12-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ12-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ12-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ12-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ12-C5': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[0] : ''
									}
								}
								break
							case 13:
								answers = {
									...answers,
									'SPQ-13': {
										'SPQ13-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ13-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ13-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ13-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ13-C5': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[0] : ''
									}
								}
								break
							case 14:
								answers = {
									...answers,
									'SPQ-14': {
										'SPQ14-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ14-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ14-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ14-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ14-C5': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[0] : ''
									}
								}
								break
							default:
						}
					} else if (tipo === 2) { //Abierta
						answers = { ...answers, [`PA-${d.idPregunta}`]: d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : '' }
					} else if (tipo === 3) { //Cerrada
						answers = { ...answers, [`PC-${d.idPregunta}`]: d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta) : '' }
					} else if (tipo === 4) { //Cerrada con comentario
						answers = {
							...answers,
							[`PCCR-${d.idPregunta}`]: d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta) : '',
							[`PCC-${d.idPregunta}`]: d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : '',
						}
					}

				})
			}
			dispatch({ type: GET_QUESTIONS, Obj: data })
			dispatch({ type: SET_ANSWERS, Obj: answers })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const saveQuestions = (form, id, tipo, idPadre) => {

	let { idDonataria, idCorrida, idProyecto } = form
	let obj = {
		idDonataria: idDonataria,
		idCorrida: idCorrida,
		idProyecto: idProyecto
	}
	if (tipo === 1) { //Especial

		switch (idPadre) {
			case 1:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-1']['SPQ1-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-1']['SPQ1-C2']
									}]
								}
							}]
						}
					}
				}
				break
			case 2: {

			const objetivos = form["SPQ-2"].objetivos

			const metasArr = (idObjetivo) => {
				const objetivo = Utils.getItem(objetivos, { id: idObjetivo })
				return objetivo.metas.map(m => m.meta.idMeta)
			}

			const indicadoresArr = (idObjetivo, param) => {
				const objetivo = Utils.getItem(objetivos, { id: idObjetivo })
				return objetivo.metas.map(m => m[param])
			}

			const respuesta = [
				{
					idRespuesta: 1,
					textoRespuesta: [objetivos[0].objetivo.idObjetivo]
				},
				{
					idRespuesta: 2,
					textoRespuesta: metasArr(objetivos[0].objetivo.idObjetivo)
				},
				{
					idRespuesta: 3,
					textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCobertura')
				},
				{
					idRespuesta: 4,
					textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas')
				},
				{
					idRespuesta: 5,
					textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					})
				},
				{
					idRespuesta: 6,
					textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					})
				},
				{
					idRespuesta: 7,
					textoRespuesta: objetivos.length > 1 ? [objetivos[1].objetivo.idObjetivo] : ['']
				},
				{
					idRespuesta: 8,
					textoRespuesta: objetivos.length > 1 ? metasArr(objetivos[1].objetivo.idObjetivo) : ['', '']
				},
				{
					idRespuesta: 9,
					textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCobertura') : ['', '']
				},
				{
					idRespuesta: 10,
					textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas') : ['', '']
				},
				{
					idRespuesta: 11,
					textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					}) : ['', '']
				},
				{
					idRespuesta: 12,
					textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					}) : ['', '']
				}]

				obj = {
				...obj,
				pregunta: {
					idPregunta: id,
					formularios: {
						formulario: [{
							idFormulario: 1,
							respuestas: {
								respuesta
							}
						}]
					}
				}
			}
		}

				break
			case 3:
				obj = {
					...obj,
					"pregunta": {
						"idPregunta": id,
						"formularios": {
							"formulario": [{
								"idFormulario": 1,
								"respuestas": {
									"respuesta": [
										{
											"idRespuesta": 1,
											"textoRespuesta": [
												form['SPQ-3']['SPQ3-C1'] || 0,
												form['SPQ-3']['SPQ3-C3'] || 0,
												form['SPQ-3']['SPQ3-C5'] || 0,
												form['SPQ-3']['SPQ3-C7'] || 0,
												form['SPQ-3']['SPQ3-C9'] || 0,
												form['SPQ-3']['SPQ3-C11'] || 0,
												form['SPQ-3']['SPQ3-C13'] || 0
											]
										},
										{
											"idRespuesta": 2,
											"textoRespuesta": [
												form['SPQ-3']['SPQ3-C2'] || 0,
												form['SPQ-3']['SPQ3-C4'] || 0,
												form['SPQ-3']['SPQ3-C6'] || 0,
												form['SPQ-3']['SPQ3-C8'] || 0,
												form['SPQ-3']['SPQ3-C10'] || 0,
												form['SPQ-3']['SPQ3-C12'] || 0,
												form['SPQ-3']['SPQ3-C14'] || 0
											]
										},
										{
											"idRespuesta": 3,
											"textoRespuesta": [
												form['SPQ-3']['SPQ3-C22'] || 0,
												form['SPQ-3']['SPQ3-C23'] || 0,
												form['SPQ-3']['SPQ3-C24'] || 0,
												form['SPQ-3']['SPQ3-C25'] || 0,
												form['SPQ-3']['SPQ3-C26'] || 0,
												form['SPQ-3']['SPQ3-C27'] || 0,
												form['SPQ-3']['SPQ3-C28'] || 0
											]
										}
									]
								}
							},
							{
								"idFormulario": 2,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C15'] || 0,
											form['SPQ-3']['SPQ3-C16'] || 0,
											form['SPQ-3']['SPQ3-C17'] || 0,
											form['SPQ-3']['SPQ3-C18'] || 0
										]
									},{
										"idRespuesta": 2,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C33'] || 0,
											form['SPQ-3']['SPQ3-C35'] || 0,
											form['SPQ-3']['SPQ3-C37'] || 0,
											form['SPQ-3']['SPQ3-C39'] || 0
										]
									},{
										"idRespuesta": 3,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C34'] || 0,
											form['SPQ-3']['SPQ3-C36'] || 0,
											form['SPQ-3']['SPQ3-C38'] || 0,
											form['SPQ-3']['SPQ3-C40'] || 0
										]
									}]
								}
							},
							{
								"idFormulario": 3,
								"respuestas": {
									"respuesta": [
										{
											"idRespuesta": 1,
											"textoRespuesta": form['SPQ-3']['SPQ3-C20'].toString() || ''
										},
										{
											"idRespuesta": 2,
											"textoRespuesta": form['SPQ-3']['SPQ3-C20'] === 1 ? form['SPQ-3']['SPQ3-C21'] : ''
										}]
								}
							},
							{
								"idFormulario": 4,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": form["SPQ-3"]["SPQ3-C31"] === 1 ? form['SPQ-3']['SPQ3-C19'] : 0 || 0
									}]
								}
							},
							{
								"idFormulario": 5,
								"respuestas": {
									"respuesta": [
										{
											"idRespuesta": 1,
											"textoRespuesta": form['SPQ-3']['SPQ3-C29'].toString() || ''
										},
										{
											"idRespuesta": 2,
											"textoRespuesta": form['SPQ-3']['SPQ3-C29'] === 1 ? form['SPQ-3']['SPQ3-C30'] : ''
										}]
								}
							},
							{
								"idFormulario": 6,
								"respuestas": {
									"respuesta": [
										{
											"idRespuesta": 1,
											"textoRespuesta": form['SPQ-3']['SPQ3-C31'].toString() || ''
										},
										{
											"idRespuesta": 2,
											"textoRespuesta": form['SPQ-3']['SPQ3-C31'] === 1 ? form['SPQ-3']['SPQ3-C32'] : ''
										},
										{
											"idRespuesta": 3,
											"textoRespuesta": form['SPQ-3']['SPQ3-C31'] === 1 ? form['SPQ-3']['SPQ3-C63'] : ''
										}]
								}
							},
							{
								"idFormulario": 7,
								"respuestas": {
									"respuesta": [
										{
											"idRespuesta": 1,
											"textoRespuesta": form['SPQ-3']['SPQ3-C41'].toString() || ''
										}
									]
								}
							},
							{
								"idFormulario": 8,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C42'] ? 0 : form['SPQ-3']['SPQ3-C42'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C45'] ? 0 : form['SPQ-3']['SPQ3-C45'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C48'] ? 0 : form['SPQ-3']['SPQ3-C48'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C51'] ? 0 : form['SPQ-3']['SPQ3-C51']
										]
									},{
										"idRespuesta": 2,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C43'] ? 0 : form['SPQ-3']['SPQ3-C43'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C46'] ? 0 : form['SPQ-3']['SPQ3-C46'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C49'] ? 0 : form['SPQ-3']['SPQ3-C49'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C52'] ? 0 : form['SPQ-3']['SPQ3-C52']
										]
									},{
										"idRespuesta": 3,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C44'] ? 0 : form['SPQ-3']['SPQ3-C44'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C47'] ? 0 : form['SPQ-3']['SPQ3-C47'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C50'] ? 0 : form['SPQ-3']['SPQ3-C50'],
											form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C53'] ? 0 : form['SPQ-3']['SPQ3-C53']
										]
									}]
								}
							},
							{
								"idFormulario": 9,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C54'] || 0,
											form['SPQ-3']['SPQ3-C55'] || 0,
											form['SPQ-3']['SPQ3-C56'] || 0,
											form['SPQ-3']['SPQ3-C57'] || 0,
											form['SPQ-3']['SPQ3-C58'] || 0,
											form['SPQ-3']['SPQ3-C59'] || 0,
											form['SPQ-3']['SPQ3-C60'] || 0
										]
									},{
										"idRespuesta": 2,
										"textoRespuesta": [
											form['SPQ-3']['SPQ3-C55']*1 === 0 || form['SPQ-3']['SPQ3-C55'] === null ? "." : form['SPQ-3']['SPQ3-C61'],
											form['SPQ-3']['SPQ3-C60']*1 === 0 || form['SPQ-3']['SPQ3-C60'] === null ? "." : form['SPQ-3']['SPQ3-C62']
										]
									}]
								}
							}]
						}
					}
				}
				break
			case 4: {

			const objetivos = form["SPQ-2"].objetivos

			const metasArr = (idObjetivo) => {
				const objetivo = Utils.getItem(objetivos, { id: idObjetivo })
				return objetivo.metas.map(m => m.meta.idMeta)
			}

			const indicadoresArr = (idObjetivo, param) => {
				const objetivo = Utils.getItem(objetivos, { id: idObjetivo })
				return objetivo.metas.map(m => m[param])
			}

			const prodCobertura = (idObjetivo) => {
				const objetivo = Utils.getItem(objetivos, {id:idObjetivo})
				return objetivo.metas.map(m => form["SPQ-4"][`SPQ4-CP${m.meta.idMeta}`])
			}

			const procesosCobertura = (idObjetivo) => {
				const objetivo = Utils.getItem(objetivos, {id:idObjetivo})
				return objetivo.metas.map(m => form["SPQ-4"][`SPQ4-CC${m.meta.idMeta}`])
			}

			const productosArr = (idObjetivo,param) => {
				const objetivo = Utils.getItem(objetivos, {id: idObjetivo })
				return objetivo.metas.map(m =>{
					return m[param].split(",").map( i => form["SPQ-4"][`SPQ4-RP${i}`]).toString().replace(/,/g,"|")
				})
			}

			const procesosArr = (idObjetivo,param) => {
				const objetivo = Utils.getItem(objetivos, {id: idObjetivo })
				return objetivo.metas.map(m => {
					return m[param].split(",").map( i => form["SPQ-4"][`SPQ4-RC${i}`]).toString().replace(/,/g,"|")
				})
			}

			const respuesta = [
				{
					idRespuesta: 1,
					textoRespuesta: metasArr(objetivos[0].objetivo.idObjetivo)
				},
				{
					idRespuesta: 2,
					textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCobertura')
				},
				{
					idRespuesta: 3,
					textoRespuesta: prodCobertura(objetivos[0].objetivo.idObjetivo)
				},
				{
					idRespuesta: 4,
					textoRespuesta: procesosCobertura(objetivos[0].objetivo.idObjetivo)
				},
				{
					idRespuesta: 5,
					textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					})
				},
				{
					idRespuesta: 6,
					textoRespuesta: productosArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					})
				},
				{
					idRespuesta: 7,
					textoRespuesta:  procesosArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					})
				},
				{
					idRespuesta: 8,
					textoRespuesta: objetivos.length > 1 ? metasArr(objetivos[1].objetivo.idObjetivo) : ['', '']
				},
				{
					idRespuesta: 9,
					textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCobertura') : ['', '']
				},
				{
					idRespuesta: 10,
					textoRespuesta: objetivos.length > 1 ? prodCobertura(objetivos[1].objetivo.idObjetivo) : ['', '']
				},
				{
					idRespuesta: 11,
					textoRespuesta: objetivos.length > 1 ? procesosCobertura(objetivos[1].objetivo.idObjetivo) : ['', '']
				},
				{
					idRespuesta: 12,
					textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					}) : ['', '']
				},
				{
					idRespuesta: 13,
					textoRespuesta: objetivos.length > 1 ? productosArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					}) : ['', '']
				},
				{
					idRespuesta: 14,
					textoRespuesta: objetivos.length > 1 ? procesosArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(i => {
						if (!i) {
							i = "0"
						}
						return i
					}) : ['', '']
				}]

				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta
								}
							}]
						}
					}
				}
			}
				break
			case 5:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C2']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-5']['SPQ5-C3']
									},
									{
										idRespuesta: 4,
										textoRespuesta: ''
									},
									{
										idRespuesta: 5,
										textoRespuesta: form['SPQ-5']['SPQ5-C4']
									},
									{
										idRespuesta: 6,
										textoRespuesta: form['SPQ-5']['SPQ5-C5']
									}]
								}
							},
							{
								idFormulario: 2,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C9']*1 === 1 ? form['SPQ-5']['SPQ5-C6'] : ""
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C9']*1 === 1 ? form['SPQ-5']['SPQ5-C7'] : ""
									},
									{
										idRespuesta: 3,
										textoRespuesta: ( form['SPQ-5']['SPQ5-C9']*1 === 1 ) ? form["SPQ-5"]["SPQ5-C7"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C8'] : "" : ""
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C9']
									}]
								}
							},
							{
								idFormulario: 3,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C13']*1 === 1 ? form['SPQ-5']['SPQ5-C10'] : ""
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C13']*1 === 1 ? form['SPQ-5']['SPQ5-C11'] : ""
									},
									{
										idRespuesta: 3,
										textoRespuesta: ( form['SPQ-5']['SPQ5-C13']*1 === 1 ) ? form["SPQ-5"]["SPQ5-C11"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C12'] : "" : ""
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C13']
									}]
								}
							},
							{
								idFormulario: 4,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C17']*1 === 1 ? form['SPQ-5']['SPQ5-C14'] : ""
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C17']*1 === 1 ? form['SPQ-5']['SPQ5-C15'] : ""
									},
									{
										idRespuesta: 3,
										textoRespuesta: ( form['SPQ-5']['SPQ5-C17']*1 === 1 ) ? form["SPQ-5"]["SPQ5-C15"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C16'] : "" : ""
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C17']
									}]
								}
							},
							{
								idFormulario: 5,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C21']*1 === 1 ? form['SPQ-5']['SPQ5-C18'] : ""
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C21']*1 === 1 ? form['SPQ-5']['SPQ5-C19'] : ""
									},
									{
										idRespuesta: 3,
										textoRespuesta: ( form['SPQ-5']['SPQ5-C21']*1 === 1 ) ? form["SPQ-5"]["SPQ5-C19"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C20'] : "" : ""
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C21']
									}]
								}
							},
							{
								idFormulario: 6,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C25']*1 === 1 ? form['SPQ-5']['SPQ5-C22'] : ""
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C25']*1 === 1 ? form['SPQ-5']['SPQ5-C23'] : ""
									},
									{
										idRespuesta: 3,
										textoRespuesta: ( form['SPQ-5']['SPQ5-C25']*1 === 1 ) ? form["SPQ-5"]["SPQ5-C23"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C24'] : "" : ""
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C25']
									}]
								}
							}]
						}
					}
				}
				break
			case 6:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C2']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C3']
									},
									{
										idRespuesta: 4,
										textoRespuesta: ''
									},
									{
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C4']
									},
									{
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C5']
									}]
								}
							},
							{
								idFormulario: 2,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C6']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C7']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C8']
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-6']['SPQ6-C9']
									},
									{
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C10']
									},
									{
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C11']
									},
									{
										idRespuesta: 7,
										textoRespuesta: form['SPQ-6']['SPQ6-C11']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C12']
									},
									{
										idRespuesta: 8,
										textoRespuesta: form['SPQ-6']['SPQ6-C11']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C13']
									},
									{
										idRespuesta: 9,
										textoRespuesta: form['SPQ-6']['SPQ6-C11']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C14']
									},
									{
										idRespuesta: 10,
										textoRespuesta: form['SPQ-6']['SPQ6-C11']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C15']
									}]
								}
							},
							{
								idFormulario: 3,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C16']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C17']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C18']
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-6']['SPQ6-C19']
									},
									{
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C20']
									},
									{
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C21']
									},
									{
										idRespuesta: 7,
										textoRespuesta: form['SPQ-6']['SPQ6-C21']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C22']
									},
									{
										idRespuesta: 8,
										textoRespuesta: form['SPQ-6']['SPQ6-C21']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C23']
									},
									{
										idRespuesta: 9,
										textoRespuesta: form['SPQ-6']['SPQ6-C21']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C24']
									},
									{
										idRespuesta: 10,
										textoRespuesta: form['SPQ-6']['SPQ6-C21']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C25']
									}]
								}
							},
							{
								idFormulario: 4,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C26']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C27']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C28']
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-6']['SPQ6-C29']
									},
									{
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C30']
									},
									{
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C31']
									},
									{
										idRespuesta: 7,
										textoRespuesta: form['SPQ-6']['SPQ6-C31']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C32']
									},
									{
										idRespuesta: 8,
										textoRespuesta: form['SPQ-6']['SPQ6-C31']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C33']
									},
									{
										idRespuesta: 9,
										textoRespuesta: form['SPQ-6']['SPQ6-C31']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C34']
									},
									{
										idRespuesta: 10,
										textoRespuesta: form['SPQ-6']['SPQ6-C31']*1 === 0 ? "" : form['SPQ-6']['SPQ6-C35']
									}]
								}
							}]
						}
					}
				}
				break
			case 7:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-7']['SPQ7-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-7']['SPQ7-C2']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-7']['SPQ7-C3']
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-7']['SPQ7-C4']
									},
									{
										idRespuesta: 5,
										textoRespuesta: ''
									},
									{
										idRespuesta: 6,
										textoRespuesta: form['SPQ-7']['SPQ7-C5']
									},
									{
										idRespuesta: 7,
										textoRespuesta: form['SPQ-7']['SPQ7-C6']
									}]
								}
							}]
						}
					}
				}
				break
			case 8: {

			const objetivos = form["SPQ-2"].objetivos
			const indicadores = form["SPQ-8"].obj

			const indicadoresArr = (idObjetivo, param) => {
				const objetivo = Utils.getItem(objetivos, { id: idObjetivo })
				return objetivo.metas.map(m => m[param])
			}

			const evaluacionArr = (idObjetivo) => {
				const indicador = Utils.getItem(indicadores, {id: idObjetivo})
				if (!indicador) {
					return ['', '']
				} else {
					return indicador.indicadores.map(m => m.evaluacion)
				}
			}

			const verificacionArr = (idObjetivo) => {
				const indicador = Utils.getItem(indicadores, {id: idObjetivo})
				if (!indicador) {
					return ['', '']
				} else {
					return indicador.indicadores.map(m => m.verificacion)
				}
			}

			const respuesta = [{
						idRespuesta: 1,
						textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados')
					},
					{
						idRespuesta: 2,
						textoRespuesta: evaluacionArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados')
					},
					{
						idRespuesta: 3,
						textoRespuesta: verificacionArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados')
					},
					{
						idRespuesta: 4,
						textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados') : ['', '']
					},
					{
						idRespuesta: 5,
						textoRespuesta: objetivos.length > 1 ? evaluacionArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados') : ['', '']
					},
					{
						idRespuesta: 6,
						textoRespuesta: objetivos.length > 1 ? verificacionArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados') : ['', '']
					}]

				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta
								}
							}]
						}
					}
				}
			}
				break
			case 9:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: [
											form['SPQ-9']['SPQ9-C1'],
											form['SPQ-9']['SPQ9-C5'] ? form['SPQ-9']['SPQ9-C5'] : '',
											form['SPQ-9']['SPQ9-C9'] ? form['SPQ-9']['SPQ9-C9'] : '',
											form['SPQ-9']['SPQ9-C13'] ? form['SPQ-9']['SPQ9-C13'] : '',
											form['SPQ-9']['SPQ9-C17'] ? form['SPQ-9']['SPQ9-C17'] : ''
										]
									},
									{
										idRespuesta: 2,
										textoRespuesta: [
											form['SPQ-9']['SPQ9-C2'],
											form['SPQ-9']['SPQ9-C6'] ? form['SPQ-9']['SPQ9-C6'] : '',
											form['SPQ-9']['SPQ9-C10'] ? form['SPQ-9']['SPQ9-C10'] : '',
											form['SPQ-9']['SPQ9-C14'] ? form['SPQ-9']['SPQ9-C14'] : '',
											form['SPQ-9']['SPQ9-C18'] ? form['SPQ-9']['SPQ9-C18'] : ''
										]
									},
									{
										idRespuesta: 3,
										textoRespuesta: [
											form['SPQ-9']['SPQ9-C3'],
											form['SPQ-9']['SPQ9-C7'] ? form['SPQ-9']['SPQ9-C7'] : '',
											form['SPQ-9']['SPQ9-C11'] ? form['SPQ-9']['SPQ9-C11'] : '',
											form['SPQ-9']['SPQ9-C15'] ? form['SPQ-9']['SPQ9-C15'] : '',
											form['SPQ-9']['SPQ9-C19'] ? form['SPQ-9']['SPQ9-C19'] : ''
										]
									},
									{
										idRespuesta: 4,
										textoRespuesta: [
											form['SPQ-9']['SPQ9-C4'],
											form['SPQ-9']['SPQ9-C8'] ? form['SPQ-9']['SPQ9-C8'] : '',
											form['SPQ-9']['SPQ9-C12'] ? form['SPQ-9']['SPQ9-C12'] : '',
											form['SPQ-9']['SPQ9-C16'] ? form['SPQ-9']['SPQ9-C16'] : '',
											form['SPQ-9']['SPQ9-C20'] ? form['SPQ-9']['SPQ9-C20'] : ''
										]
									}]
								}
							}]
						}
					}
				}
				break
			case 10:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-10']['SPQ10-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-10']['SPQ10-C2']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-10']['SPQ10-C3']
									},
									{
										idRespuesta: 4,
										textoRespuesta: ( form['SPQ-10']['SPQ10-C1'] === 'Alto' || form['SPQ-10']['SPQ10-C2'] === 'Alto' || form['SPQ-10']['SPQ10-C3'] === 'Alto') ? form['SPQ-10']['SPQ10-C4'] : ""
									}]
								}
							}]
						}
					}
				}
				break
			case 11:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-11']['SPQ11-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-11']['SPQ11-C1'] === 1 ? form['SPQ-11']['SPQ11-C2'] : ""
									}]
								}
							}]
						}
					}
				}
				break
			case 12:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-12']['SPQ12-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-12']['SPQ12-C2']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-12']['SPQ12-C3']
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-12']['SPQ12-C4']
									},
									{
										idRespuesta: 5,
										textoRespuesta: ( form['SPQ-12']['SPQ12-C2'] === 'Alto' || form['SPQ-12']['SPQ12-C3'] === 'Alto' || form['SPQ-12']['SPQ12-C4'] === 'Alto') ? form['SPQ-12']['SPQ12-C5'] : ""
									}]
								}
							}]
						}
					}
				}
				break
			case 13:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-13']['SPQ13-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-13']['SPQ13-C2']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-13']['SPQ13-C3']
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-13']['SPQ13-C4']
									},
									{
										idRespuesta: 5,
										textoRespuesta: ( form['SPQ-13']['SPQ13-C2'] === 'Alto' || form['SPQ-13']['SPQ13-C3'] === 'Alto' || form['SPQ-13']['SPQ13-C4'] === 'Alto') ? form['SPQ-13']['SPQ13-C5'] : ""
									}]
								}
							}]
						}
					}
				}
				break
			case 14:
				obj = {
					...obj,
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-14']['SPQ14-C1']
									},
									{
										idRespuesta: 2,
										textoRespuesta: form['SPQ-14']['SPQ14-C2']
									},
									{
										idRespuesta: 3,
										textoRespuesta: form['SPQ-14']['SPQ14-C3']
									},
									{
										idRespuesta: 4,
										textoRespuesta: form['SPQ-14']['SPQ14-C4']
									},
									{
										idRespuesta: 5,
										textoRespuesta: ( form['SPQ-14']['SPQ14-C2'] === 'Alto' || form['SPQ-14']['SPQ14-C3'] === 'Alto' || form['SPQ-14']['SPQ14-C4'] === 'Alto') ? form['SPQ-14']['SPQ14-C5'] : ""
									}]
								}
							}]
						}
					}
				}
				break
			default:
		}
	} else if (tipo === 2) { //Abierta
		obj = {
			...obj,
			pregunta: {
				idPregunta: id,
				formularios: {
					formulario: [{
						idFormulario: 1,
						respuestas: {
							respuesta: [{
								idRespuesta: 1,
								textoRespuesta: form[`PA-${id}`]
							}]
						}
					}]
				}
			}
		}
	} else if (tipo === 3) { //Cerrada
		obj = {
			...obj,
			pregunta: {
				idPregunta: id,
				formularios: {
					formulario: [{
						idFormulario: 1,
						respuestas: {
							respuesta: [{
								idRespuesta: 1,
								textoRespuesta: form[`PC-${id}`]
							}]
						}
					}]
				}
			}
		}
	} else if (tipo === 4) { //Cerrada con comentario
		obj = {
			...obj,
			pregunta: {
				idPregunta: id,
				formularios: {
					formulario: [{
						idFormulario: 1,
						respuestas: {
							respuesta: [{
								idRespuesta: 1,
								textoRespuesta: form[`PCCR-${id}`]
							},
							{
								idRespuesta: 2,
								textoRespuesta: !form[`PCC-${id}`][0] ? "N/A" : form[`PCC-${id}`]
							}]
						}
					}]
				}
			}
		}
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/saveQuestions',
			method: "POST",
			data: { ...obj },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearQuestions = () => {

	return (dispatch) => {
		dispatch({ type: GET_QUESTIONS, Obj: { preguntas: { pregunta: [] } } })
		dispatch({ type: SET_ANSWERS, Obj: {} })
		return Promise.resolve()
	}
}

export const exportReport = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/exportReport',
			method: 'POST',
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(response => {
			dispatch(isLoading(false))
			const blob = new Blob([response.data], { type: 'application/pdf' })
			const fileName = `proyecto-documento-${Utils.getToday()}.pdf`
			const objectUrl = URL.createObjectURL(blob)
			const a = document.createElement('a')

			a.href = objectUrl
			a.download = fileName
			document.body.appendChild(a)
			a.click()

			document.body.removeChild(a)
			URL.revokeObjectURL(objectUrl)
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Opportunities/Projects.js